<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('studentTransfer.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.studentName')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editData.student.full_name_en"
                    disabled
                  />
                  <div class="validate" v-if="errors.has('student_id')">
                    {{ errors.first('student_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-8">
                  <ts-checkbox
                    v-model="chk_current_branch"
                    @change="setCurrentBranch"
                    >{{ $t('studentTransfer.toCurrentBranch') }}</ts-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="!chk_current_branch">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.toBranch')
                }}</label>
                <div class="col-md-8">
                  <treeselect
                    :placeholder="$t('studenttransfer.typeforsearch')"
                    :options="
                      branchs.map(i => ({
                        id: i.branch_id,
                        label: i.branch_name_en
                      }))
                    "
                    v-model.number="model.to_branch_id"
                  ></treeselect>
                  <div class="validate" v-if="errors.has('to_branch_id')">
                    {{ errors.first('to_branch_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.fromClass')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editData.from_class.class_name"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.toClass')
                }}</label>
                <div class="col-md-8">
                  <ts-loading-banner :loading="fetch_to_class">
                    <treeselect
                      :placeholder="$t('studenttransfer.typeforsearch')"
                      :options="
                        toClasses.map(i => ({
                          id: i.class_id,
                          label: i.class_name + '_' + i.teacher.full_name_en
                        }))
                      "
                      v-model.number="model.enroll_class_id"
                    ></treeselect>
                    <div class="validate" v-if="errors.has('enroll_class_id')">
                      {{ errors.first('enroll_class_id') }}
                    </div>
                  </ts-loading-banner>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.date')
                }}</label>
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.date_transfer"
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('date_transfer')">
                    {{ errors.first('date_transfer') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('studentTransfer.comment')
                }}</label>
                <div class="col-md-8">
                  <textarea
                    rows="4"
                    class="form-control"
                    v-model="model.comment"
                  ></textarea>
                  <div class="validate" v-if="errors.has('comment')">
                    {{ errors.first('comment') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12 text-right">
              <ts-button
                class="btn-default mr-2"
                @click.prevent="$emit('close')"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                class="btn-primary ml-2"
                @click.prevent="update"
                :waiting="saving"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'studentTransferEdit',
  props: ['editData'],
  data () {
    return {
      model: {
        transfer_id: 0,
        student_id: null,
        to_branch_id: null,
        enroll_class_id: null,
        from_class_id: null,
        date_transfer: moment().format('DD-MM-YYYY'),
        comment: null
      },
      errors: new Errors(),
      branchs: [],
      saving: false,
      saving_new: false,
      chk_current_branch: true,
      fetch_from_class: false,
      fetch_to_class: false,
      loadingPreData: false
    }
  },
  async created () {
    this.loadingPreData = true
    await Promise.all([this.fetchStudent(), this.fetchBranch()]).then(() => {
      this.loadingPreData = false
      this.setEditData()
    })
  },
  computed: {
    ...mapState('studentTransfer', ['students', 'toClasses', 'fromClasses'])
  },
  methods: {
    ...mapActions('studentTransfer', [
      'fetchStudent',
      'fetchClass',
      'fetchCurrentClass'
    ]),
    setCurrentBranch () {
      this.model.to_branch_id = null
      this.model.enroll_class_id = null
      this.$store.commit('studentTransfer/RECEIVE_TO_CLASSES', [])
    },
    fetchBranch () {
      this.$store
        .dispatch('branch/fetch', {
          page: -1,
          fields: {
            setup_branch_profiles: 'branch_id,branch_name_en'
          },
          filter: {
            exclude_current: true
          }
        })
        .then(response => {
          this.branchs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    update () {
      this.errors = new Errors()
      this.saving = true
      let data = Object.assign({}, this.model, {
        chk_current_branch: this.chk_current_branch
      })
      this.$store
        .dispatch('studentTransfer/update', {
          transfer_id: this.editData.transfer_id,
          ...data
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    setEditData () {
      if (!_.isEmpty(this.editData)) {
        if (this.editData.from_branch_id === this.editData.to_branch_id) {
          this.chk_current_branch = true
        }
        if (this.editData.from_branch_id != this.editData.to_branch_id) {
          this.chk_current_branch = false
        }
        this.model = {
          transfer_id: this.editData.transfer_id,
          student_id: this.editData.student_id,
          to_branch_id: this.editData.to_branch_id,
          enroll_class_id: this.editData.enroll_class_id,
          from_class_id: this.editData.from_class_id,
          date_transfer: moment(this.editData.date_transfer).format(
            'DD-MM-YYYY'
          ),
          comment: this.editData.comment
        }
      }
    },
    clearForm () {
      this.model = {
        student_id: '',
        to_branch_id: '',
        enroll_class_id: '',
        from_class_id: '',
        date_transfer: moment().format('DD-MM-YYYY'),
        comment: ''
      }
    }
  },
  watch: {
    'model.to_branch_id': function (val) {
      this.fetch_to_class = true
      this.$store.commit('studentTransfer/RECEIVE_TO_CLASSES', [])
      this.model.enroll_class_id = null
      this.fetchClass({ branch_id: [val] }).then(() => {
        this.fetch_to_class = false
        this.model.enroll_class_id = this.editData.enroll_class_id
      })
    },
    'model.student_id': function (val) {
      this.$store.commit('studentTransfer/RECEIVE_FROM_CLASSES', [])
      if (val) {
        this.fetch_from_class = true
        this.fetchCurrentClass({ student_id: [val] }).then(() => {
          this.fetch_from_class = false
        })
      }
    },
    'model.from_class_id': function (val) {
      this.$store.commit('studentTransfer/RECEIVE_TO_CLASSES', [])
      this.model.enroll_class_id = null
      if (val && !this.model.to_branch_id) {
        this.fetch_to_class = true
        this.fetchClass({ class_id: [val] }).then(() => {
          this.fetch_to_class = false
          this.model.enroll_class_id = this.editData.enroll_class_id
        })
      }
      if (val && this.model.to_branch_id) {
        this.fetch_to_class = true
        this.fetchClass({ branch_id: [this.model.to_branch_id] }).then(() => {
          this.fetch_to_class = false
          this.model.enroll_class_id = this.editData.enroll_class_id
        })
      }
    },
    chk_current_branch: function (val) {
      if (val) {
        this.fetch_to_class = true
        this.$store.commit('studentTransfer/RECEIVE_TO_CLASSES', [])
        this.model.enroll_class_id = null
        this.fetchClass().then(() => {
          this.fetch_to_class = false
        })
      }
    }
  }
}
</script>
